// Animated concentric charge-ring motif
export default function ChargeRing({ size = 320, className = "", opacity = 1 }) {
  const rings = [0, 0.9, 1.8];
  return (
    <div
      className={`pointer-events-none relative ${className}`}
      style={{ width: size, height: size, opacity }}
      aria-hidden
    >
      {rings.map((delay, i) => (
        <span
          key={i}
          className="absolute inset-0 rounded-full border border-revo-green/50"
          style={{ animation: `ring-expand 2.7s ${delay}s cubic-bezier(0.22,1,0.36,1) infinite` }}
        />
      ))}
      <span
        className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-revo-green"
        style={{ boxShadow: "0 0 24px 6px rgba(47,213,118,0.7)" }}
      />
    </div>
  );
}
